module.exports = __webpack_public_path__ + "img/dash-truck.eadc23d5.png";